import { useEffect, useState } from "react";
import { Card, Table, Tag, Select, Button, message } from "antd";
import { Link, useLocation } from "react-router-dom";
import { listWorkspaceSubscriptionsApi } from "../api/admin.workspaces.api";

const { Option } = Select;

function WorkspaceSubscriptionsManagement() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
  const [statusFilter, setStatusFilter] = useState(query.get("status") || "active");
  const paidParam = query.get("paid");
  const planKey = query.get("plan_key") || undefined;
  const unreplacedDays = query.get("unreplaced_days");

  const fetchData = async (page = 1, status = statusFilter) => {
    try {
      setLoading(true);
      const res = await listWorkspaceSubscriptionsApi({
        page,
        page_size: pagination.pageSize,
        status: status || undefined,
        paid: paidParam === null ? undefined : paidParam === "true",
        plan_key: planKey,
        unreplaced_days:
          status === "canceled" && unreplacedDays ? Number(unreplacedDays) : undefined,
      });
      if (res.data.status === "success") {
        const data = res.data.data || {};
        setRows((data.subscriptions || []).map((r) => ({
          ...r,
          key: r.subscription_id || r.workspace_id,
        })));
        setPagination((p) => ({ ...p, current: data.page || page, total: data.total || 0 }));
      } else {
        message.error(res.data.message);
      }
    } catch (e) {
      message.error("Failed to load workspace subscriptions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const nextStatus = new URLSearchParams(location.search).get("status") || "active";
    setStatusFilter(nextStatus);
    fetchData(1, nextStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const columns = [
    {
      title: "Workspace",
      dataIndex: "name",
      render: (name, r) => (
        <Link to={`/workspaces/${r.workspace_id}`}>{name}</Link>
      ),
    },
    { title: "Owner", dataIndex: "owner_email" },
    { title: "Plan", dataIndex: "plan_name" },
    {
      title: "Status",
      dataIndex: "subscription_status",
      render: (s) => <Tag color="green">{s}</Tag>,
    },
    {
      title: "MRR",
      dataIndex: "mrr",
      render: (v, row) =>
        typeof v === "number" && v > 0 && row.mrr_currency
          ? `${row.mrr_currency} ${Number(v).toFixed(2)}`
          : "—",
    },
    { title: "Seats", key: "seats", render: (_, r) => `${r.seats_used}${r.seats_limit != null ? `/${r.seats_limit}` : ""}` },
  ];

  return (
    <div className="layout-content">
      <Card
        title="Workspace subscriptions"
        extra={
          <>
            <Select
              value={statusFilter}
              style={{ width: 140, marginRight: 8 }}
              onChange={(v) => {
                setStatusFilter(v);
                fetchData(1, v);
              }}
            >
              <Option value="active">Active</Option>
              <Option value="past_due">Past due</Option>
              <Option value="canceled">Canceled</Option>
            </Select>
            <Button onClick={() => fetchData(pagination.current)}>Refresh</Button>
          </>
        }
      >
        <Table
          loading={loading}
          columns={columns}
          dataSource={rows}
          pagination={{
            ...pagination,
            onChange: (page) => fetchData(page),
          }}
        />
      </Card>
    </div>
  );
}

export default WorkspaceSubscriptionsManagement;
